<template>
    <div>
        <v-select
                :items="['both','passenger','captain']"
                label="Filter"
                v-model="filter"
        />
        <data-table url="debug_view" :initial-url-search-params="params" :enable-delete="false" :enable-add="false"
                    :enable-edit="false"/>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "DebugView",
        components: {DataTable},
        data() {
            return {
                filter: 'both'
            }
        },
        computed: {
            params() {
                const params = new URLSearchParams();

                params.append('filter', this.filter);

                return params;
            }
        },
        title: "Debug View"
    }
</script>

<style scoped>

</style>